import type { DmNotificationLevelCounts } from '../../../services/dmNotifications';
import { LEVEL_COUNT_ENTRIES } from './dmNotificationLevels';
import { NotificationLevelPill } from './NotificationLevelPill';

export function NotificationLevelCounts({ counts }: { counts: DmNotificationLevelCounts }) {
    const entries = LEVEL_COUNT_ENTRIES.filter((entry) => counts[entry.key] > 0);
    if (entries.length === 0) return <span className="text-xs text-gray-400">-</span>;
    return (
        <span className="flex flex-wrap items-center gap-1.5">
            {entries.map((entry) => (
                <NotificationLevelPill
                    key={entry.key}
                    level={entry.level}
                    count={counts[entry.key]}
                />
            ))}
        </span>
    );
}
